import { Link } from 'react-router-dom';
import { Camera } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/lib/auth';
import { isLandingDomain, getAppUrl } from '@/lib/domainConfig';
import { useTranslation } from 'react-i18next';
import { LanguageSwitcher } from '@/components/LanguageSwitcher';

export function MarketingHeader() {
  const { user, loading } = useAuth();
  const { t } = useTranslation();

  return (
    <header className="border-b border-border/50">
      <div className="container flex h-14 items-center justify-between">
        <Link to="/" className="flex items-center gap-2 hover:opacity-80 transition-opacity">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-foreground">
            <Camera className="h-4 w-4 text-background" />
          </div>
          <span className="text-lg font-semibold tracking-tight">PrepFrame</span>
        </Link>
        <nav className="flex items-center gap-1">
          <LanguageSwitcher variant="compact" />
          <Button variant="ghost" size="sm" className="hidden sm:inline-flex" asChild>
            <Link to="/blog">{t('blog')}</Link>
          </Button>
          <Button variant="ghost" size="sm" className="hidden sm:inline-flex" asChild>
            <Link to="/pricing">{t('pricing')}</Link>
          </Button>
          {loading ? (
            <div className="w-20 h-8" />
          ) : user ? (
            <Button size="sm" asChild>
              {isLandingDomain() ? (
                <a href={getAppUrl('/dashboard')}>{t('dashboard')}</a>
              ) : (
                <Link to="/dashboard">{t('dashboard')}</Link>
              )}
            </Button>
          ) : (
            <>
              <Button variant="outline" size="sm" asChild>
                {isLandingDomain() ? (
                <a href={getAppUrl('/auth')}>{t('login')}</a>
                ) : (
                  <Link to="/auth">{t('login')}</Link>
                )}
              </Button>
              <Button size="sm" asChild>
                {isLandingDomain() ? (
                  <a href={getAppUrl('/auth?mode=signup')}>{t('signup')}</a>
                ) : (
                  <Link to="/auth?mode=signup">{t('signup')}</Link>
                )}
              </Button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
